export const EMPTY_FORM_STATE = {
  mediaDerecha: '',
  mediaIzquierda: '',
  dsDerecha: '',
  dsIzquierda: '',
};
